<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670 mt-4`"
        :hideHeader="true"
        :hideFooter="false"
        :newLayout="true"
    >
        <template slot="card-body">
            <div class=" d-flex justify-content-center mb-4">
                <svg-rndr
                    v-if="paymentStatus == 'SUCCESS'"
                    svg="check-circle-green.svg"
                    :width="110"
                />
                <svg-rndr
                    v-else
                    svg="warning.svg"
                    :width="110"
                />
            </div>
            <h1 class="text-white text-center mb-4 heading-larger">
                <template
                    v-if="paymentStatus == 'SUCCESS'"
                    v-translate
                >
                    Success!
                </template>
                <template
                    v-else
                    v-translate
                >
                    Failure!
                </template>
            </h1>
             <div class="form-row justify-content-center mb-4 text-center">
                <div class="col-md-8">
                    <div v-if="showResponse">
                        <template v-if="paymentStatus == 'SUCCESS'">
                            <p
                                class="text-standard mb-4"
                                v-if='payment.subscription.months > 0'
                                v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                            >
                                The first %{ freq } subscription payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                            </p>
                            <p
                                class="text-standard mb-4"
                                v-else
                                v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                            >
                                A payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                            </p>
                            <div class="text-center">
                                <a
                                    href="#"
                                    class="btn btn-primary"
                                    @click.prevent="complete"
                                >
                                    <span
                                        v-if="go_to_smartcharts"
                                        v-translate
                                    >Proceed To SmartCharts</span>
                                    <span
                                        v-else
                                        v-translate
                                    >Proceed To LMS</span>
                                </a>
                            </div>
                        </template>
                        <template v-else>
                            <h3 v-translate>There was a problem processing your payment, please wait a few minutes and try again.</h3>
                            <div class="form-group form-row justify-content-center mt-4 mb-0">
                                <div class="col-md-3 text-center">
                                    <a
                                        href="/my-subscriptions"
                                        v-translate
                                        class="link d-block mt-3"
                                    >Back to subscriptions</a>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div
                        v-else
                        class="loader loader--only"
                    >
                        <loader />
                    </div>
                </div>
            </div>
        </template>
        <template slot="card-footer">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-auto text-center ml-md-auto">
                    <a
                        href="/my-subscriptions"
                        v-translate
                         class="text-white btn btn-hollow btn--chunky border-white border-white--lightest"
                    >Back to subscriptions</a>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { paymentFrequencyForPurchaseOption } from '@H/enrolment';
import FlashMessage from '@C/FlashMessage';
import Card from '@C/Card.vue';

export default {
    name: 'UpgradeSubscriptionResponse',
    components: {
        FlashMessage,
        Card
    },
    data() {
        return {
            showResponse: false
        }
    },
    mounted() {
        this.loadPaymentConfirmation()
            .then(payment => {
                this.showResponse = true;
            })
            .catch(err => {
                this.showResponse = true;
            });

        if (this.paymentStatus == 'SUCCESS') {
            this.sendConfirmationEmail();
        }
    },
    methods: {
        ...mapActions({
            loadPaymentConfirmation: 'MySubscriptions/loadPaymentConfirmation',
            sendConfirmationEmail: 'MySubscriptions/sendConfirmationEmail',
            complete: 'Enrolment/complete'
        }),
    },
    computed: {
        ...mapState('Auth', ['go_to_smartcharts']),
        ...mapState('Widget', ['payment', 'paymentStatus']),
        paymentFrequency() {
            return paymentFrequencyForPurchaseOption(this.payment.subscription.months);
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/MySubscriptions/Response.vue